<template>
  <div class="app-container">
    <BjPage ref="BjPage" :selection="selection" @handleSelectionChange="handleSelectionChange" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :search-btn-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- tab1 -->
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.companySeller')" prop="clientCode">
            <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('billingPage.companySeller')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.CATime')" prop="updateTime">
            <BjDateRangePicker v-model="queryParamsUpdateTime" :placeholder="$t('billingPage.CATime')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.CAaccountF')" prop="balanceFrom">
            <BjInputNumber v-model="queryParams.balanceFrom" :placeholder="$t('billingPage.CAaccountF')" class="full-width" clearable :controls="false" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.CAaccountT')" prop="balanceTo">
            <BjInputNumber v-model="queryParams.balanceTo" :placeholder="$t('billingPage.CAaccountT')" class="full-width" clearable :controls="false" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan/2" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.totalBalance1')" prop="totalBalance">
            <span :style="totalBalance < 0 ? 'color:red;font-weight: bold;' : 'color:#082dc3;font-weight: bold;'">{{ totalBalance }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan/2" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.totalAvailable1')" prop="totalAvailable">
            <span :style="totalAvailable < 0 ? 'color:red;font-weight: bold;' : 'color:#082dc3;font-weight: bold;'">{{ totalAvailable }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan/2" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.totalCredit1')" prop="totalCredit">
            <span :style="totalCredit < 0 ? 'color:red;font-weight: bold;' : 'color:#082dc3;font-weight: bold;'">{{ totalCredit }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan/2" v-if="queryParamsTradeStatus == '0'">
          <el-form-item :label="$t('billingPage.totalUnpaid1')" prop="totalUnpaid">
            <span :style="totalUnpaid < 0 ? 'color:red;font-weight: bold;' : 'color:#082dc3;font-weight: bold;'">{{ totalUnpaid }}</span>
          </el-form-item>
        </el-col>

        <!-- tab2 -->
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '1'">
          <el-form-item :label="$t('billingPage.companySeller')" prop="clientCodes">
            <BjSelectLov multiple v-model="queryParams.clientCodes" :option-list="clientCodeList" :placeholder="$t('billingPage.companySeller')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '1'">
          <el-form-item :label="$t('billingPage.source')" prop="source">
            <BjSelectLov v-model="queryParams.source" :option-list="sourceList" :placeholder="$t('billingPage.source')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="queryParamsTradeStatus == '1'">
          <el-form-item :label="$t('billingPage.gmtCreate')" prop="updateTime">
            <BjDateRangePicker v-model="queryParamsTransTime" :placeholder="$t('billingPage.gmtCreate')" @change="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item, index) in CSG_CLIENTACCOUNTS_TAB_LIST" :key="index" :label="$t(item.label)" :name="item.value" />
          </el-tabs>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <!-- tab1 前端导出 -->
          <BjFrontendExport
            v-if="queryParamsTradeStatus == '0'"
            type="primary"
            class="main-btn"
            :label-list="labelList"
            :rows="selectedRows"
            file-name="Wallet Balance.csv"
          />
          <!-- tab2 后端导出 -->
          <el-button type="primary" class="main-btn" @click="onExport2" v-if="queryParamsTradeStatus == '1'">{{ $t('exportText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'balance'">
                {{ scope.row.balance }}
              </span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { billApi } from '@/api';
  import {
    CSG_CLIENTACCOUNTS_TAB_LIST,
  } from '@/utils/constants';
  import { downloadBlob } from '@/utils/index';

  export default {
    name: 'BusinessBillingClientAccounts',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        selection: true,
        CSG_CLIENTACCOUNTS_TAB_LIST,
        queryParamsUpdateTime: [],
        queryParamsTransTime: [],
        queryApi: billApi.getMyCAPageList,
        queryParams: {
          clientCode: null,
          startDate: null,
          endDate: null,
          balanceFrom: null,
          balanceTo: null,
        },
        labelList1: [
          { label: this.$t('billingPage.CustomerName'), prop: 'customerName', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.CAemail'), prop: 'email', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.CAaccount'), prop: 'balance', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.CATime'), prop: 'updateTime', isCheck: true, disabled: false, export: { dateFormat: 'DD/MM/YYYY HH:mm' } },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
        labelList2: [
          { label: this.$t('billingPage.CustomerName'), prop: 'customerName', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.DEPID'), prop: 'paymentId', isCheck: true, disabled: false },
          { label: this.$t('billingPage.source'), prop: 'source', isCheck: true, disabled: false },
          { label: this.$t('billingPage.DEPAmount'), prop: 'amount', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Operator'), prop: 'operator', isCheck: true, disabled: false },
          { label: this.$t('billingPage.gmtCreate'), prop: 'transactionTime', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Status'), prop: 'status', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
        totalBalance:null,
        queryParamsTradeStatus: '0',
        sourceList: [],
      };
    },
    computed: {
      labelList() {
        if (this.queryParamsTradeStatus === '0') {
          return this.labelList1;
        } else if (this.queryParamsTradeStatus === '1') {
          return this.labelList2;
        } 
      },
    },
    mounted() {
      this.getClientInfoList();
      this.getSource();
      this.getTotalBalance();
    },
    watch: {
      queryParamsUpdateTime(v) {
        this.queryParams.startDate = (v || [])[0];
        this.queryParams.endDate = (v || [])[1];
      },
      queryParamsTransTime(v) {
        this.queryParams.startTime = (v || [])[0];
        this.queryParams.endTime = (v || [])[1];
      },
    },
    methods: {
      // tab页点击事件
      handleTabClick(tab, event) {
        this.queryParamsTradeStatus = tab.name;
        this.queryParamsUpdateTime = [];
        this.queryParamsTransTime = [];
        if (tab.name == '0') {
          this.selection = true
          this.queryApi = billApi.getMyCAPageList;
          this.queryParams={
            clientCode: null,
            startDate: null,
            endDate: null,
            balanceFrom: null,
            balanceTo: null,
          }
        } else if (tab.name == '1') {
          this.selection = false
          this.queryApi = billApi.getMyDepositClientAccount;
          this.queryParams={
            clientCodes: [],
            source: null,
            startTime: null,
            endTime: null,
          }
        }
        setTimeout(() => { this.reFresh(); }, 500);
      },
      getTotalBalance(){
        // billApi.getTotalBalanceData().then(res => {
        //   this.totalBalance = res.data || null;
        // });
        billApi.getTotalStatistics().then(res => {
          this.totalBalance = res.data.balance || 0.00;
          this.totalAvailable = res.data.available || 0.00;
          this.totalCredit = res.data.credit || 0.00;
          this.totalUnpaid = res.data.unpaid || 0.00;
        });
      },
      /** 后端导出(1) **/
      async onExport2() {
        billApi.exportTransactionsList({...this.queryParams,page: 0,pageSize: 99999}).then(res => {
          downloadBlob(res, `Wallet Transaction.csv`);
        });
      },
      // 获取所有客户信息列表
      getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
      },
      // 获取钱包交易来源
      getSource() {
        billApi.getSelectWalletSource().then(res => {
          this.sourceList = res.data;
        });
      },
      onView(row) {
        // tab1 
        if(this.queryParamsTradeStatus == '0'){
          this.$router.push({
            // 我的钱包 页
            name: 'BusinessBillingMyDeposit',
            query: { clientCode:row.clientCode },
          });
        }
        // tab2 
        if(this.queryParamsTradeStatus == '1'){
          if(row.source == 'Prepay'){ 
            // 钱包 页
            this.$toPage('BusinessBillingDeposit');
          }else if(row.source == 'Credit Note'){
            this.$toPage('BusinessBillingServiceInvoices');
          }else if(row.source == 'Invoice Payment' && this.$store.getters.cusId){
            // user ==> my invoice页面
            this.$toPage('BusinessBillingServiceInvoices');
          }else if(row.source == 'Invoice Payment' && !this.$store.getters.cusId){
            // admin ==> invoice页面
            this.$toPage('BusinessBillingInvoices');
          }
        }
      },
      beforeResetSearch() {
        this.queryParamsUpdateTime = []
        this.queryParamsTransTime = []
        if (this.queryParamsTradeStatus == '0') {
          this.queryParams={
            clientCode: null,
            startDate: null,
            endDate: null,
            balanceFrom: null,
            balanceTo: null,
          }
        } else if (this.queryParamsTradeStatus == '1') {
          this.queryParams={
            clientCodes: [],
            source: null,
            startTime: null,
            endTime: null,
          }
        } 
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
